/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ArrowLeft = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M10.6785 20L3.88565 13.2328C3.5457 12.8941 2.62695 12.0039 2.62695 12.0039C2.62695 12.0039 3.54217 11.1094 3.88564 10.7672L10.6785 4L11.7392 5.05665L5.51953 11.2528L21.3731 11.2528V12.7472H5.51953L11.7392 18.9433L10.6785 20Z"
                        fill={color}
                    />
                </svg>
        );
    };
